module.exports = {"330604001":"百官街道","330604002":"曹娥街道","330604003":"东关街道","330604100":"道墟镇","330604101":"长塘镇","330604102":"上浦镇","330604103":"汤浦镇","330604104":"章镇镇","330604105":"下管镇","330604106":"丰惠镇","330604107":"永和镇","330604108":"梁湖镇","330604109":"驿亭镇","330604110":"小越镇","330604111":"谢塘镇","330604112":"盖北镇","330604113":"崧厦镇","330604114":"沥海镇","330604200":"岭南乡","330604201":"陈溪乡","330604202":"丁宅乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330604.json
// module id = 914
// module chunks = 0